

<template>
  <div class="signup bg-gray height-100">
    <b-container class='py-4'>
      <b-row>
        <b-col cols='8' class='mx-auto mt-4'>
          <b-card class='org-session'>
          <div class="container" >
            <b-row>
              <div  class="col-6 mx-auto my-5 py-3">
                <h3 class="text-center">ログアウトしますか？</h3>
                <b-button block class='bg-orange mt-4 regist-button' @click='logout'>ログアウト</b-button>
              </div>
            </b-row>
          </div>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  components: { },
  data () {
    return {
      idToken: localStorage.idToken,
    }
  },
  methods: {
    logout() {
      localStorage.idToken = ''
      this.$store.commit('organization/setOrg', null);
      Auth.signOut().then(() =>{
        this.$swal.fire({
          icon: 'success',
          title: this.$i18n.t('message.do_logout')
        }).then(()=>{
          this.$router.push('/organization')
        })

      })
      .catch(error => {
        console.log(error)
      })
    },
  },
  mounted(){
    this.$store.commit('setLoading', false)
  },
}
</script>

<style scoped lang="scss">
.height-100 {
  height: 100%;
}
</style>
